export function stripFourByteUnicode(value) {
  if (typeof value !== 'string') return value;
  return Array.from(value)
    .filter(character => character.codePointAt(0) <= 0xFFFF)
    .join('');
}
